import { type AxiosResponse } from 'axios'

import axiosInstance from 'api/axiosInstance'
import { type GetVerifyMyAgeUrlResponse } from 'types/api/verify'
import { type IIdentityVerificationCallbackResponse } from 'types/interfaces/IIdentityVerificationCallbackResponse'

export const getVerifyMyAgeUrl = async (): Promise<string> => {
    const {
        data: { data }
    } = await axiosInstance<AxiosResponse<GetVerifyMyAgeUrlResponse>>({
        method: 'POST',
        url: '/api/vmc/identity-verification'
    })
    return data.message
}

export const verifyMyAgeCallback = async (values: any) => {
    const { data } = await axiosInstance<
        AxiosResponse<IIdentityVerificationCallbackResponse>
    >({
        method: 'GET',
        url: '/api/vmc/identity-verification/callback',
        params: values
    })
    return data
}